module.exports = __webpack_public_path__ + "assets/img/header.48a79dd5.jpg";